module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.5cbf5cdc.ttf";